import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="relative overflow-hidden bg-zinc-950">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[560px]">
        <div className="flex flex-col justify-center px-8 md:px-16 lg:px-24 py-20 relative z-10">
          <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-rose-500 via-rose-400 to-transparent"></div>

          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-px bg-rose-500"></div>
            <span className="text-rose-400 text-xs font-semibold uppercase tracking-[0.25em]">Get Started</span>
          </div>

          <h2
            className="text-4xl md:text-6xl font-black text-white leading-tight mb-8"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Ready to Take<br />Control of<br />
            <span className="text-rose-500">Your Health?</span>
          </h2>

          <p className="text-zinc-400 text-sm leading-relaxed mb-10 max-w-md">
            Join thousands of patients who trust AxisPoint Medical for their primary care needs. New patients welcome — same-day appointments available.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/book-appointment"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-rose-500 text-white font-bold rounded-full hover:bg-rose-400 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              Book Your Appointment
              <span className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-full group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
            <a
              href="tel:+17025550192"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border border-zinc-700 text-zinc-300 hover:border-zinc-500 hover:text-white font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-phone-line"></i>
              (702) 555-0192
            </a>
          </div>
        </div>

        <div className="relative h-[300px] lg:h-auto">
          <img
            src="https://public.readdy.ai/ai/img_res/dce8c606684b90fa1d6bc2cf36d1be99.jpg"
            alt="Healthy lifestyle"
            className="w-full h-full object-cover object-top opacity-50"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/40 to-transparent lg:bg-gradient-to-l"></div>
        </div>
      </div>
    </section>
  );
}
